// Ends the wait for a transcription the moment the completer Lambda finishes it, off the back of the
// PushEventService poll.
//
// A recording is finalised by a Lambda, seconds to a minute after the mic stops. Until now the only
// way to learn it had finished was to ask: the recorder asked once a second for up to two minutes,
// and the transcription modal asked every three. Those were the most expensive polls in the app,
// and they were per tab - a second person looking at the same patient never saw the result land at
// all. The Lambda now publishes when it writes the final text, so a view following a transcription
// is told, and the poll behind it can be slow and rarely reached.
//
// Unlike the patient-record services this matches on the transcription, not the patient: the views
// that care are following one specific recording.
//
//   TranscriptionLiveUpdateService.subscribe($scope, {
//       transcriptionId: function () { return followedId; },
//       onFinished: function (payload) { ... payload.status is COMPLETED or FAILED ... },
//   });
app.service("TranscriptionLiveUpdateService", [
	"LiveReloadService",
	"PUSH_EVENTS",
	function (LiveReloadService, PUSH_EVENTS) {
		/**
		 * Wires a view up to the finish of the transcription it is following, for the life of its scope.
		 *
		 * @param scope the view's scope; listeners are removed when it is destroyed
		 * @param spec  transcriptionId() - the transcription being followed; falsy when none is
		 *              onFinished(payload) - called once with the event payload; status is filled in
		 *                  from the event type when the payload does not carry it
		 */
		function subscribe(scope, spec) {
			function onEvent(status, pushEvent) {
				const payload = angular.extend({}, (pushEvent && pushEvent.data) || {});
				const followed = spec.transcriptionId();
				if (!followed || !payload.transcriptionId || !LiveReloadService.sameId(followed, payload.transcriptionId)) {
					return;
				}
				if (!payload.status) {
					payload.status = status;
				}
				spec.onFinished(payload);
			}

			scope.$on(PUSH_EVENTS.TRANSCRIPTION_COMPLETED, function (e, pushEvent) {
				onEvent("COMPLETED", pushEvent);
			});
			scope.$on(PUSH_EVENTS.TRANSCRIPTION_FAILED, function (e, pushEvent) {
				onEvent("FAILED", pushEvent);
			});
		}

		const service = {
			subscribe: subscribe,
		};

		return service;
	},
]);
